import { useExperiment } from '@hungryroot/experiments';
import { ResumeFunnelButton } from '@hungryroot/funnel';
import { tastesAndNeedsCta } from '@hungryroot/homepage';
import { PRE_AUTH_CATALOG_RECIPES_ROUTE } from '@hungryroot/routes';
import { buttonClickedEvent } from '@hungryroot/segment';
import { islandRoot } from '../IslandRoot/IslandRoot';

function TastesAndNeedsCta({
  defaultText,
  queryParam,
}: {
  defaultText: string;
  queryParam?: string;
}) {
  const preAuthCatalogVariant = useExperiment(199);

  if (preAuthCatalogVariant === undefined) {
    return null;
  }

  const isVariant = preAuthCatalogVariant > 0;
  const baseUrl = isVariant ? PRE_AUTH_CATALOG_RECIPES_ROUTE : undefined;
  const url = queryParam && baseUrl ? `${baseUrl}?${queryParam}` : baseUrl;

  return (
    <ResumeFunnelButton
      style="muted"
      prominence="primary"
      size="medium"
      startQuizText={isVariant ? 'Browse our catalog' : defaultText}
      resumeQuizText={isVariant ? 'Browse our catalog' : undefined}
      ctaLink={isVariant ? url : undefined}
      className={tastesAndNeedsCta}
      onClick={() => {
        buttonClickedEvent({
          button_name: isVariant ? 'browse_our_catalog_taste' : 'get_started',
          order_id: null,
          page_position: '',
        });
      }}
    />
  );
}

export const TastesAndNeedsCtaIsland = islandRoot(TastesAndNeedsCta);
